import React, { FC } from 'react';

import { Text } from '../Typography';
import { ClassName, cn } from '../../utils';
import styles from './index.module.scss';


export type BadgeProps = ClassName & {
    count: string | number;
    /**
     * The upper limit for the number. A greater value will be displayed
     * in the form of: limit+ (e.g. 99+)
     */
    limit?: number;
}

/**
 * Used in the side menu to display the number of unprocessed registers or
 * in the chat modal window to display unread messages.
 */
export const Badge: FC<BadgeProps> = ({ className, count, limit = 100 }) => (
    <Text component='div' textType='bold' className={cn(styles.badge, className)}>
        <span>{count > limit ? `${limit}+` : count}</span>
    </Text>
);
